<template>
  <div class="performance-wrapper">
    <h1 class="title-screen" style="font-size: 20px">Performance dates</h1>
    <div v-for="(performance, index) in vs.$each.$iter" :key="performance.id">
      <performance
        :initial-values="performance"
        :index="parseInt(index)"
        :organization-slug="organizationSlug"
        :venues="venues"
        :promo-codes="promoCodes"
        :ticket-types="ticketTypes"
        :vs="performance"
        :ticket-sellers="ticketSellers"
        @duplicatePerformance="handleDuplicatePerformance"
        @refetchOrderItemAndVenue="handleRefetchOrderItemAndVenue"
        @removePerformance="removePerformance"
        @removeSelectedTicketSellers="removeSelectedTicketSellers"
      />
    </div>
    <main-button style="margin-top: 8px" flat depressed @click="addPerformance">
      <span class="add-symbol">+</span>Add date
    </main-button>
    <div class="buttons-wrapper" style="margin-top: 58px">
      <main-button text="CANCEL" flat depressed @click="goBack()" />
      <div class="buttons">
        <main-button flat outline @click="$emit('back')">
          <v-icon class="arrow-back"> arrow_back </v-icon>
          <span>back</span>
        </main-button>
        <main-button text="CREATE EVENT" :disabled="submittingForm" @click="handleEmitCreatePerformance()" />
      </div>
    </div>
  </div>
</template>

<script>
import performance from './performance.vue'
import { v4 as uuid } from 'uuid'
import { GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES_AND_PROMO_CODES } from '@/graphql/orderItemTemplate.graphql'
import { GET_NON_BOX_OFFICE_TICKET_SELLERS } from '@/graphql/user.graphql'

export default {
  name: 'performance-container',
  components: {
    performance,
  },
  props: {
    initialValues: {
      type: Array,
      default: () => [],
    },
    vs: {
      type: Object,
      default: () => {},
    },
    organizationSlug: String,
    submittingForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.initialValues,
      venues: [],
      ticketTypes: [],
      promoCodes: [],
      ticketSellers: [],
    }
  },
  watch: {
    venues: function (val) {
      this.$emit('venueChange', val)
    },
  },
  mounted() {
    this.fetchTicketTypesAndVenues()
    this.fetchTicketSellers()
  },
  methods: {
    handleDuplicatePerformance(performanceData) {
      const { id, date, time, ...info } = performanceData
      this.form.push({ ...info, id: uuid() })
    },
    async handleRefetchOrderItemAndVenue() {
      await this.fetchTicketTypesAndVenues()
    },
    addPerformance() {
      this.form.push({ id: uuid() })
    },
    removePerformance(id) {
      this.form = this.form.filter(performance => performance.id !== id)
      this.$emit('removePerformance', this.form)
    },
    handleEmitCreatePerformance() {
      this.removePromoCodesFromPerformancesWithoutRegularTicket()
      this.$emit('createPerformance', this.form)
    },
    removePromoCodesFromPerformancesWithoutRegularTicket() {
      const allOrganizationRegularTicketIds = this.ticketTypes
        .filter(t => !t.membership && !t.ticketSeller && t.prepaidCoupon)
        .map(t => t.id)
      this.form = this.form.map(p => {
        if (p.orderItemTemplateIds.find(id => allOrganizationRegularTicketIds.includes(id))) {
          return p
        } else {
          return { ...p, promoCodeIds: [] }
        }
      })
    },
    async fetchTicketTypesAndVenues() {
      const {
        data: {
          getOrganizationOrderItemTemplates,
          getOrganizationVenues,
          getAllOrganizationPromoCodes,
        },
        errors,
      } = await this.$apollo.query({
        query: GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES_AND_PROMO_CODES,
        variables: {
          organizationSlug: this.organizationSlug,
          pagination: this.pagination,
        },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          message: 'Oops, Something went wrong!',
          color: 'error',
        }
      } else {
        this.venues = getOrganizationVenues.organizationVenues.map(venue => venue.venue)
        this.ticketTypes = getOrganizationOrderItemTemplates
        this.promoCodes = getAllOrganizationPromoCodes
      }
    },
    async fetchTicketSellers() {
      const {
        data: { getNonBoxOfficeTicketSellers: ticketSellers },
      } = await this.$apollo.query({
        query: GET_NON_BOX_OFFICE_TICKET_SELLERS,
        variables: { organizationSlug: this.organizationSlug },
      })

      this.ticketSellers = ticketSellers.map(ts => {
        return {
          ...ts,
          id: Number(ts.id),
        }
      })
    },
    removeSelectedTicketSellers(performanceId) {
      const performance = this.form.find(item => item.id === performanceId)
      if (!performance) {
        return
      }

      performance.ticketSellerIds = undefined
    },
  },
}
</script>

<style scoped></style>
